import type { ComponentPropsWithRef } from "react";

import { cn } from "@intergamma/common/cn";

export function Store({ className, ...props }: ComponentPropsWithRef<"svg">) {
  return (
    <>
      <svg
        className={cn("karwei:hidden", className)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5 7.20001C5 6.92387 5.22386 6.70001 5.5 6.70001H6.5C6.77614 6.70001 7 6.92387 7 7.20001V8.20001C7 8.47615 6.77614 8.70001 6.5 8.70001H5.5C5.22386 8.70001 5 8.47615 5 8.20001V7.20001Z"
          fill="currentColor"
        />
        <path
          d="M9.5 6.70001C9.22386 6.70001 9 6.92387 9 7.20001V8.20001C9 8.47615 9.22386 8.70001 9.5 8.70001H10.5C10.7761 8.70001 11 8.47615 11 8.20001V7.20001C11 6.92387 10.7761 6.70001 10.5 6.70001H9.5Z"
          fill="currentColor"
        />
        <path
          d="M13 7.20001C13 6.92387 13.2239 6.70001 13.5 6.70001H14.5C14.7761 6.70001 15 6.92387 15 7.20001V8.20001C15 8.47615 14.7761 8.70001 14.5 8.70001H13.5C13.2239 8.70001 13 8.47615 13 8.20001V7.20001Z"
          fill="currentColor"
        />
        <path
          d="M17.5 6.70001C17.2239 6.70001 17 6.92387 17 7.20001V8.20001C17 8.47615 17.2239 8.70001 17.5 8.70001H18.5C18.7761 8.70001 19 8.47615 19 8.20001V7.20001C19 6.92387 18.7761 6.70001 18.5 6.70001H17.5Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.25 5C0.25 3.48122 1.48122 2.25 3 2.25H21C22.5188 2.25 23.75 3.48122 23.75 5V20C23.75 20.9665 22.9665 21.75 22 21.75H2C1.0335 21.75 0.25 20.9665 0.25 20V5ZM3 3.75C2.30964 3.75 1.75 4.30964 1.75 5V20C1.75 20.1381 1.86193 20.25 2 20.25H5.25V13.407C5.25 12.4405 6.0335 11.657 7 11.657H17C17.9665 11.657 18.75 12.4405 18.75 13.407V20.25H22C22.1381 20.25 22.25 20.1381 22.25 20V5C22.25 4.30964 21.6904 3.75 21 3.75H3ZM11.25 13.157V20.25H6.75V13.407C6.75 13.269 6.86193 13.157 7 13.157H11.25ZM17.25 20.25V13.407C17.25 13.269 17.1381 13.157 17 13.157H12.75V20.25H17.25Z"
          fill="currentColor"
        />
      </svg>
      <svg
        className={cn("gamma:hidden", className)}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.40002 7.60699C5.40002 7.38222 5.58224 7.2 5.80702 7.2H6.79303C7.01781 7.2 7.20002 7.38222 7.20002 7.60699V8.59301C7.20002 8.81778 7.01781 9 6.79303 9H5.80702C5.58224 9 5.40002 8.81778 5.40002 8.59301V7.60699Z"
          fill="currentColor"
        />
        <path
          d="M9.60702 7.2C9.38224 7.2 9.20002 7.38222 9.20002 7.60699V8.59301C9.20002 8.81778 9.38224 9 9.60702 9H10.593C10.8178 9 11 8.81778 11 8.59301V7.60699C11 7.38222 10.8178 7.2 10.593 7.2H9.60702Z"
          fill="currentColor"
        />
        <path
          d="M13 7.60699C13 7.38222 13.1822 7.2 13.407 7.2H14.393C14.6178 7.2 14.8 7.38222 14.8 7.60699V8.59301C14.8 8.81778 14.6178 9 14.393 9H13.407C13.1822 9 13 8.81778 13 8.59301V7.60699Z"
          fill="currentColor"
        />
        <path
          d="M17.207 7.2C16.9822 7.2 16.8 7.38222 16.8 7.60699V8.59301C16.8 8.81778 16.9822 9 17.207 9H18.193C18.4178 9 18.6 8.81778 18.6 8.59301V7.60699C18.6 7.38222 18.4178 7.2 18.193 7.2H17.207Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 2.5C1.44772 2.5 1 2.94771 1 3.5V21.5H23V3.5C23 2.94772 22.5523 2.5 22 2.5H2ZM22 3.5H2V20.5H5.5V13.407C5.5 12.8548 5.94772 12.407 6.5 12.407H17.5C18.0523 12.407 18.5 12.8548 18.5 13.407V20.5H22V3.5ZM11.5 20.5H6.5V13.407H11.5V20.5ZM12.5 20.5H17.5V13.407H12.5V20.5Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
}
